import { render, staticRenderFns } from "./category.vue?vue&type=template&id=1fe4e7f3&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&id=1fe4e7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4e7f3",
  null
  
)

export default component.exports